import { render, staticRenderFns } from "./BrandTableRow.vue?vue&type=template&id=3ff8d45a&scoped=true&"
import script from "./BrandTableRow.vue?vue&type=script&lang=js&"
export * from "./BrandTableRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff8d45a",
  null
  
)

export default component.exports